import React from "react";
import { connect } from "react-redux";

import "../../styles/banner.css";
import { Heading } from "../TextComponents";
import Filters from "./Filters";
import DateFilter from "./DateFilter";
import Sorting from "./Sorting";
import Budget from "./Budget";
import TourType from "./TourType";
// import Duration from "./Duration";

const Banner = ({ query }) => {
  return (
    <div className="t-container-fluid trodly__landing__page__banner__container">
      <div className="t-container-fluid trodly__landing_page__banner">
        <Heading style={{ textAlign: "center", margin: 0, padding: "1.4rem 0 0", textTransform: "capitalize" }}>
          Discover & book exciting activities
        </Heading>
      </div>
      <div className="t-container-fluid trodly__landing_page__banner" id="banner__container__sticky_header">
        <Filters />
        <div className="banner__sortings__dates__filters">
          <div>
            <DateFilter active={query.date.from} />
          </div>
          <div>
            <Sorting active={query.sort.sort} />
          </div>
          <div>
            <Budget active={query.price.to ? true : false} />
          </div>
          <div>
            <TourType active={query.tourType ? true : false} />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  return {
    query: state.queryString
  };
};
export default connect(mapStateToProps)(Banner);
